export const PXCartridge = (function () {
  'use strict'

  function init() {
    // If form exists on page, add event listeners
    if (jQuery('.calculator__main').length) events()
  }

  function events() {
    // On cartridge input change
    jQuery('.calculator__form').submit(function (event) {
      event.preventDefault()

      const data = jQuery(this).serializeArray()
      //console.log(data)

      // Get number of connections
      const connections = +data[1].value

      const container = jQuery(this).closest('.calculator__main')

      // Ensure value non negative
      if (connections < 0) {
        container.find('.cartridge-error').text(cartridgeError)
        return
      }

      // Set number of cartridges required to input
      const per = parseFloat(data[0].value)
      const number = connections / per
      const cartridges = number.toFixed(2)
      //container.find('.cartridges').val(cartridges)
      container.find('.total_cartridges').text(Math.ceil(cartridges))
      container.find('.cartridge-error').text('')
    })

    jQuery('.clear-cart').click(event => {
      const container = jQuery(event.target).closest('.calculator__main')
      container.find('.connections').val('')
      //container.find('.cartridges').val('')
      container.find('.total_cartridges').text('0')
      const select = container.find('.calculator__select')
      select.val(select.find('option:first').val())
    })
  }

  return { init }
})()
